import React, { useContext, useState } from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import DeviceContext from '@totem/components/devices/devicesContainer/deviceContainerContext';
import InputContext from '@totem/components/ui_components/reportSettings/InputContext';
import { Filter, Params } from '@totem/types/common';
import api from '@totem/utilities/api';
import { DEVICES_PAGINATION_ENDPOINT } from '@totem/utilities/endpoints';
import fileUtilities from '@totem/utilities/fileUtilities';

type Props = {
  deviceExportEndPoint?: string;
};
const DeviceExport = ({ deviceExportEndPoint }: Props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { selectedDevices, totalRecords } = useContext(DeviceContext);
  const { buildParameters } = useContext(InputContext);

  const buildExportParameters = (): Params => {
    if (selectedDevices.length > 0) {
      const deviceIDs = selectedDevices.map((dev) => dev.device.id);
      const filters: Filter[] = [{ field: '_id', values: deviceIDs }];
      return {
        paging: { page: 1, pageSize: selectedDevices.length },
        sort: { field: '', direction: 1 },
        filters,
      };
    }
    return buildParameters();
  };

  const exportData = async () => {
    setLoading(true);

    const params = buildExportParameters();

    const deviceUrl =
      typeof deviceExportEndPoint !== 'undefined' &&
      deviceExportEndPoint !== null
        ? deviceExportEndPoint
        : DEVICES_PAGINATION_ENDPOINT;

    const { data } = await api.post(`${deviceUrl}/export`, params);
    fileUtilities.downloadFile('devices', data);

    setLoading(false);
  };

  return (
    <Button
      type="default"
      icon={<DownloadOutlined />}
      onClick={exportData}
      loading={loading}
    >
      Export CSV (
      {selectedDevices.length > 0 ? selectedDevices.length : totalRecords})
    </Button>
  );
};

export default DeviceExport;
